import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";

import { LOGO_URL, TENANT } from "APP_ROOT/constants";
import BookmarkedParts from "APP_ROOT/Nav/BookmarkedParts/BookmarkedParts";
import { subscribe } from "APP_ROOT/modules/Admin/sessionChannel";
import { EMAIL_VERIFIED } from "MODULES/users/constants";

import SessionInfo from "./SessionInfo";
import Hamburger from "./Hamburger";
import Menu from "./Menu";
import GlobalSearch from "./GlobalSearch";
import Notifications from "./Notifications";
import RepairOrdersCart from "./RepairOrdersCart/Cart";
import SaleOrdersCart from "./SaleOrdersCart/Cart";

class Nav extends Component {
  state = {
    open: false
  };

  componentDidMount() {
    this.props.subscribeToSession();
  }

  render() {
    const { currentUser } = this.props;
    const { open } = this.state;
    const classes = classNames("collapse navbar-collapse", {
      in: open
    });

    const navClasses = classNames("navbar navbar-default navbar-fixed-top", {
      development: ["staging", "development"].includes(process.env.NODE_ENV)
    });

    const toggle = () => this.setState({ open: !open });

    return (
      <nav className={navClasses}>
        <div className="container-fluid">
          {!this.props.currentUser.get(EMAIL_VERIFIED) && (
            <div className="send-email-warning">
              Sending emails is disabled. Please contact helpdesk@infotrader.com
              to verify your email.
            </div>
          )}
          <div className="navbar-header">
            <Hamburger onClick={toggle} />
            <Link to="/" className="navbar-brand">
              <img src={currentUser.getIn([TENANT, LOGO_URL])} alt="Logo" />
            </Link>
          </div>
          <div className={classes}>
            <h1 className="navbar-text">
              {this.props.header}
              {["staging", "development"].includes(process.env.NODE_ENV) && (
                <Fragment>
                  &nbsp;
                  <span className="badge badge-environment-tag">
                    {process.env.NODE_ENV}
                  </span>
                </Fragment>
              )}
            </h1>
            <Menu />
            <ul className="nav navbar-nav navbar-right">
              <Notifications />
              <BookmarkedParts />
              <RepairOrdersCart />
              <SaleOrdersCart />
              <SessionInfo />
            </ul>
            <GlobalSearch />
          </div>
        </div>
      </nav>
    );
  }
}

export default connect(undefined, dispatch => ({
  subscribeToSession: () => dispatch(subscribe())
}))(Nav);

Nav.propTypes = {
  currentUser: PropTypes.shape({}),
  header: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/Nav/Nav.jsx